// const Host = "http://localhost:8000";
const Host = "https://nikahemuslim.com/api";
// const Host = "https://nikha-e-muslim-backend.onrender.com";
export default Host;
